/* eslint-disable no-console */
import { HttpClient, HttpParams } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { Node, NodeUpdateRequest } from '../../models/nodes.model'
import { NodeService } from './node.service'

const EXTERNAL_FILE_MANAGER_HOST = 'helios-external-overview'
export const NODE_URL = `${EXTERNAL_FILE_MANAGER_HOST}/node`
export const ACTIVATION_URL = `${EXTERNAL_FILE_MANAGER_HOST}/activate`
export const INACTIVATION_URL = `${EXTERNAL_FILE_MANAGER_HOST}/inactivate`

@Injectable({
  providedIn: 'root',
})
export class HttpNodeService extends NodeService {
  constructor(private readonly httpClient: HttpClient) {
    super()
  }

  getNodes(
    reconDate: string,
    partitionType: string,
    partitionId: number,
  ): Observable<Node[]> {
    return this.httpClient.get<Node[]>(NODE_URL, {
      params: new HttpParams()
        .set('reconDate', reconDate)
        .set('partitionType', partitionType)
        .set('partitionId', partitionId),
    })
  }

  activate(
    reconDate: string,
    partitionType: string,
    partitionId: number,
    executionIds: number[],
  ): Observable<void> {
    const nodeRequest: NodeUpdateRequest = {
      reconDate: reconDate,
      partitionType: partitionType,
      partitionId: partitionId,
      executionId: executionIds.join(','),
    }
    return this.httpClient.post<void>(ACTIVATION_URL, nodeRequest)
  }

  inactivate(
    reconDate: string,
    partitionType: string,
    partitionId: number,
    executionIds: number[],
  ): Observable<void> {
    const nodeRequest: NodeUpdateRequest = {
      reconDate: reconDate,
      partitionType: partitionType,
      partitionId: partitionId,
      executionId: executionIds.join(','),
    }
    return this.httpClient.post<void>(INACTIVATION_URL, nodeRequest)
  }
}
